import styles from './header.module.css';

function Header() {
  return (
    <header className={styles.header}>
    </header>
  )
}

export default Header